import React from 'react';
import classes from './comm-it-loader.module.scss';

export const CommItLoader: React.FC = () => (
  <div className={classes.root}>
    <div className={classes.word} aria-hidden="true">
      <span className={classes.comm}>Comm</span>
      <span className={classes.seam} />
      <span className={classes.it}>it</span>
      <span className={classes.ai}>AI</span>
      <span className={classes.line} />
    </div>
    <span className={classes.caption}>טוען נתונים…</span>
  </div>
);